"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useToggle = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const toggleReducer = (state, nextValue) => nextValue !== null && nextValue !== void 0 ? nextValue : !state;
function useToggle(initialValue = false) {
    return react_1.default.useReducer(toggleReducer, initialValue);
}
exports.useToggle = useToggle;
//# sourceMappingURL=useToggle.js.map